import { render, staticRenderFns } from "./company-card.vue?vue&type=template&id=73c41fb9&scoped=true&"
import script from "./company-card.vue?vue&type=script&lang=js&"
export * from "./company-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c41fb9",
  null
  
)

export default component.exports